export default __webpack_public_path__ + "maps-guides-styles-layers-sky-layer-960-33999321ab7fe7dbc28d2f592db815ff.png";